module.exports = __webpack_public_path__ + "static/media/usa-anli9.bc0eff73.jpg";